import React from "react";
import RpMUIDialog from "@/components/modals/RpMUIModal";
import { CloseOutlined } from "@mui/icons-material";

const EmailCampaignDetailsModal = ({
  open,
  onClose,
  imageSrc = "/img/email-campaign/50off.png",
}: {
  open: boolean;
  onClose: () => void;
  imageSrc?: string;
}) => {
  return (
    <RpMUIDialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <div className="text-right">
        <CloseOutlined onClick={onClose} className="cursor-p" />
      </div>
      <img
        src={imageSrc}
        alt="Email Campaign"
        style={{
          width: "100%",
          height: "auto",
          borderRadius: "var(--radius-container)",
          objectFit: "contain",
        }}
      />
    </RpMUIDialog>
  );
};

export default EmailCampaignDetailsModal;
